import PropTypes from 'prop-types';
import Text from '../Text/Text';
import Icon from '../Icon/Icon';

function Select({
  placeholder,
  options,
  value,
  onChange,
  onFocus,
  onBlur,
  required,
  tabIndex,
  isFocus,
  name,
}) {
  return (
    <div
      className={`aaco-input aaco-select floating-label ${
        isFocus ? 'aaco-input--is-focus' : ''
      } ${isFocus || value ? 'aaco-input--is-floating' : ''}`}
    >
      <div className="aaco-select-selected">
        <Text tag="button" style="text-black dd-kr:text-white dd-en:text-white">
          {value ? options.find((i) => i.value === value)?.label : ''}
        </Text>
      </div>
      <label htmlFor={name}>{placeholder}</label>
      <Icon
        name="chevron-down"
        width={14}
        height={14}
        className="absolute right-1 text-dark-warm-grey dd-kr:text-80-white-on-dark-blue dd-en:text-80-white-on-dark-blue dd-kr:-translate-y-0.5 dd-en:-translate-y-0.5"
      />
      <select
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        className={'absolute top-0 w-full h-full opacity-0 z-10'}
        required={required}
        tabIndex={tabIndex}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {options.map((i) => (
          <option key={i.value} value={i.value}>
            {i.label}
          </option>
        ))}
      </select>
    </div>
  );
}

Select.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  isFocus: PropTypes.bool,
  required: PropTypes.bool,
  tabIndex: PropTypes.number,
};

Select.defaultProps = {
  value: '',
  placeholder: 'SELECT',
  options: [],
  name: '',
  isFocus: false,
  required: false,
};

export default Select;
